module.exports = __webpack_public_path__ + "static/media/authpass.c06ad045.svg";